import React from "react";

function MyRespond({ className, onChange, onClick, value }) {
  return (
    <React.Fragment>
      <div className={`relative ${className}`}>
        <textarea
          type="text"
          value={value}
          className="mycomment shadow w-full h-40 rounded-md pl-3 pt-3"
          placeholder="Your Response"
          onChange={onChange}
        />
        <button
          className="postComment bg-color-2 rounded-md text-white"
          onClick={onClick}
        >
          Post
        </button>
      </div>
    </React.Fragment>
  );
}

export default MyRespond;
